// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module_iconWrapper__Fvzia {
    margin-right: 16px;
    align-self: center;

    @media screen and (min-width: 1920px) {
        margin-right: 24px;
    }
}

.styles-module_isButtonIcon__ppLXh {
    padding: 8px;
    cursor: pointer;
}

.styles-module_clearIcon__dk54o {
    cursor: pointer;

    @media (hover: hover) and (pointer: fine) {
        &:hover svg {
            fill: var(--black);
        }
    }
}

.styles-module_firstLetter__MeUqO {
    border: 2px solid var(--black);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.styles-module_firstLetterRow__vkVJJ {
    padding: 16px 24px;
}

.styles-module_sectionsWrapper__gR5hx {
    margin-bottom: 32px;
}

/* Range container for the CSS Custom Highlight API (see useSearchHighlight).
   \`display: contents\` keeps the rows direct layout children of the modal body. */
.styles-module_searchResults__RBZkx {
    display: contents;
}

.styles-module_notFoundContainer__TYWBW {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
}

.styles-module_emptyListContainer__Cbvyc {
    display: flex;
    flex: 1;
    justify-content: center;
    text-align: center;
}

.styles-module_emptyListContainerLeft__wqaXQ {
    justify-content: flex-start;
    text-align: start;
}

.styles-module_emptyListContainerRight__rrwa6 {
    justify-content: flex-end;
    text-align: end;
}

.styles-module_hasButton__fJcqN {
    flex: 0;
}

.styles-module_notFoundTextContainer__W5Et8 {
    margin: 24px 24px 16px 24px;

    h2 {
        color: var(--grey_72_lc);
    }
}

.styles-module_ghostIconWrapper__POTHS {
    margin-bottom: 16px;
}

.styles-module_templateListItem__WQZ3R {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    background: none;
    display: flex;
    width: 100%;
}

.styles-module_hoverState__yNqmg {
    cursor: pointer;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--grey_16_lc);
        }
    }

    &:active {
        background: var(--grey_8_lc);
    }
}

.styles-module_emptyContainer__QPYoF {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    max-width: 279px;
    margin: 0 24px;
}

.styles-module_emptyContainerCenter__GNp5T {
    margin: 0 48px;
}
.styles-module_emptyContainerLeft__vh5Sf {
    align-items: flex-start;
}

.styles-module_emptyContainerRight__TSfRN {
    align-items: flex-end;
}

.styles-module_disabled__7SAsX {
    opacity: 0.5;
    pointer-events: none;
}

.styles-module_emptyContainer__QPYoF.styles-module_leftCenterAligned__C5Lbl {
    margin: 0 auto;
    align-items: center;
}

.styles-module_transactionListItemWrapper__Sq257 {
    @media screen and (min-width: 708px) {
        display: flex;
    }
}

.styles-module_transactionListItemSeparatorWrapper__wfsrD {
    @media screen and (min-width: 708px) {
        min-width: 180px;
    }

    @media screen and (min-width: 889px) {
        min-width: 240px;
    }
}

.styles-module_searchPopupHeader__X4JED {
    --cw-txt-padding-top: 32px;
    --cw-txt-padding-right: 24px;
    --cw-txt-padding-bottom: 48px;
    --cw-txt-padding-left: 24px;

    @media screen and (min-width: 708px) {
        --cw-txt-padding-top: 48px;
        --cw-txt-padding-right: 32px;
        --cw-txt-padding-bottom: 64px;
        --cw-txt-padding-left: 32px;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/List/styles/styles.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;;IAElB;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;;IAEf;QACI;YACI,kBAAkB;QACtB;IACJ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;iFACiF;AACjF;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,OAAO;IACP,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,2BAA2B;;IAE3B;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;;IAEf;QACI;YACI,6BAA6B;QACjC;IACJ;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;;IAE3B;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,6BAA6B;QAC7B,2BAA2B;IAC/B;AACJ","sourcesContent":[".iconWrapper {\n    margin-right: 16px;\n    align-self: center;\n\n    @media screen and (min-width: 1920px) {\n        margin-right: 24px;\n    }\n}\n\n.isButtonIcon {\n    padding: 8px;\n    cursor: pointer;\n}\n\n.clearIcon {\n    cursor: pointer;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover svg {\n            fill: var(--black);\n        }\n    }\n}\n\n.firstLetter {\n    border: 2px solid var(--black);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.firstLetterRow {\n    padding: 16px 24px;\n}\n\n.sectionsWrapper {\n    margin-bottom: 32px;\n}\n\n/* Range container for the CSS Custom Highlight API (see useSearchHighlight).\n   `display: contents` keeps the rows direct layout children of the modal body. */\n.searchResults {\n    display: contents;\n}\n\n.notFoundContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 1;\n}\n\n.emptyListContainer {\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    text-align: center;\n}\n\n.emptyListContainerLeft {\n    justify-content: flex-start;\n    text-align: start;\n}\n\n.emptyListContainerRight {\n    justify-content: flex-end;\n    text-align: end;\n}\n\n.hasButton {\n    flex: 0;\n}\n\n.notFoundTextContainer {\n    margin: 24px 24px 16px 24px;\n\n    h2 {\n        color: var(--grey_72_lc);\n    }\n}\n\n.ghostIconWrapper {\n    margin-bottom: 16px;\n}\n\n.templateListItem {\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    background: none;\n    display: flex;\n    width: 100%;\n}\n\n.hoverState {\n    cursor: pointer;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--grey_16_lc);\n        }\n    }\n\n    &:active {\n        background: var(--grey_8_lc);\n    }\n}\n\n.emptyContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n    max-width: 279px;\n    margin: 0 24px;\n}\n\n.emptyContainerCenter {\n    margin: 0 48px;\n}\n.emptyContainerLeft {\n    align-items: flex-start;\n}\n\n.emptyContainerRight {\n    align-items: flex-end;\n}\n\n.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.emptyContainer.leftCenterAligned {\n    margin: 0 auto;\n    align-items: center;\n}\n\n.transactionListItemWrapper {\n    @media screen and (min-width: 708px) {\n        display: flex;\n    }\n}\n\n.transactionListItemSeparatorWrapper {\n    @media screen and (min-width: 708px) {\n        min-width: 180px;\n    }\n\n    @media screen and (min-width: 889px) {\n        min-width: 240px;\n    }\n}\n\n.searchPopupHeader {\n    --cw-txt-padding-top: 32px;\n    --cw-txt-padding-right: 24px;\n    --cw-txt-padding-bottom: 48px;\n    --cw-txt-padding-left: 24px;\n\n    @media screen and (min-width: 708px) {\n        --cw-txt-padding-top: 48px;\n        --cw-txt-padding-right: 32px;\n        --cw-txt-padding-bottom: 64px;\n        --cw-txt-padding-left: 32px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconWrapper": `styles-module_iconWrapper__Fvzia`,
	"isButtonIcon": `styles-module_isButtonIcon__ppLXh`,
	"clearIcon": `styles-module_clearIcon__dk54o`,
	"firstLetter": `styles-module_firstLetter__MeUqO`,
	"firstLetterRow": `styles-module_firstLetterRow__vkVJJ`,
	"sectionsWrapper": `styles-module_sectionsWrapper__gR5hx`,
	"searchResults": `styles-module_searchResults__RBZkx`,
	"notFoundContainer": `styles-module_notFoundContainer__TYWBW`,
	"emptyListContainer": `styles-module_emptyListContainer__Cbvyc`,
	"emptyListContainerLeft": `styles-module_emptyListContainerLeft__wqaXQ`,
	"emptyListContainerRight": `styles-module_emptyListContainerRight__rrwa6`,
	"hasButton": `styles-module_hasButton__fJcqN`,
	"notFoundTextContainer": `styles-module_notFoundTextContainer__W5Et8`,
	"ghostIconWrapper": `styles-module_ghostIconWrapper__POTHS`,
	"templateListItem": `styles-module_templateListItem__WQZ3R`,
	"hoverState": `styles-module_hoverState__yNqmg`,
	"emptyContainer": `styles-module_emptyContainer__QPYoF`,
	"emptyContainerCenter": `styles-module_emptyContainerCenter__GNp5T`,
	"emptyContainerLeft": `styles-module_emptyContainerLeft__vh5Sf`,
	"emptyContainerRight": `styles-module_emptyContainerRight__TSfRN`,
	"disabled": `styles-module_disabled__7SAsX`,
	"leftCenterAligned": `styles-module_leftCenterAligned__C5Lbl`,
	"transactionListItemWrapper": `styles-module_transactionListItemWrapper__Sq257`,
	"transactionListItemSeparatorWrapper": `styles-module_transactionListItemSeparatorWrapper__wfsrD`,
	"searchPopupHeader": `styles-module_searchPopupHeader__X4JED`
};
export default ___CSS_LOADER_EXPORT___;
